import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  transparent?: boolean;
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/entertainment', label: '娱乐爆料' },
    { to: '/category/business', label: '商业内幕' },
    { to: '/category/workplace', label: '职场黑料' },
    { to: '/category/social', label: '社会热点' },
    { to: '/category/tech', label: '科技揭秘' },
    { to: '/about', label: '关于我们' },
  ];

  const showBg = transparent ? isScrolled : true;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        showBg
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="container-main flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="text-2xl font-heading font-bold text-primary-500 whitespace-nowrap">
            黑料社区
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-3 py-2 text-sm rounded-md transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.to
                  ? 'text-primary-500 bg-primary-100/70 font-medium'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/about"
            className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            <i className="ri-pencil-line"></i>
            我要爆料
          </Link>
        </div>

        <button
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-foreground-950"
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {isMobileOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70 animate-fade-in-down">
          <div className="container-main py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2.5 text-sm rounded-lg transition-colors duration-200 ${
                  location.pathname === link.to
                    ? 'text-primary-500 bg-primary-100/70 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 flex items-center justify-center gap-1.5 px-4 py-2.5 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200"
            >
              <i className="ri-pencil-line"></i>
              我要爆料
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}